import { render, staticRenderFns } from "./xqsq.vue?vue&type=template&id=20907178&scoped=true"
import script from "./xqsq.vue?vue&type=script&lang=js"
export * from "./xqsq.vue?vue&type=script&lang=js"
import style0 from "./xqsq.vue?vue&type=style&index=0&id=20907178&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20907178",
  null
  
)

export default component.exports